import React, {useEffect, useRef, useState} from 'react';
import {FlatList, View, Text, Platform} from 'react-native';
import {FONT_FAMILY_BOLD, isMacOS} from '../../utils/utils';
import ReviewQuestionListItem from './ReviewQuestionListItem';
import {ImageQuestionHeader} from './ImageQuestionHeader';
import logger from '../../utils/logger';

const ReviewQuestionList = props => {
   const {
      answer,
      onRetryPressed,
      isLandscapeMode,
      isSmallScreen,
      finalQuesAnsData,
      isImageAvailable,
      isWeb,
      imageURL,
      onImageViewerPressed,
   } = props;
   const tempQues =
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s end Lorem Ipsum has been the industrys standard dummy text ever since the 1500s';
   const flatListRef = useRef();
   const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
   useEffect(() => {
      flatListRef.current.scrollToOffset({animated: false, offset: 0});
   }, [answer]);
   useEffect(() => {
      if (props.isAslQuestion || props.didVideoStopped) {
         setCurrentPlayingIndex(null);
      }
   }, [props.isAslQuestion, props.didVideoStopped]);
   const renderItem = ({item, index}) => {
      return (
         <ReviewQuestionListItem
            answerData={item}
            index={index}
            onRetryPressed={onRetryPressed}
            onItemClick={item => {
               props.onRowSelected(item);
            }}
            onSignButtonPress={url => {
               if (currentPlayingIndex === index) {
                  setCurrentPlayingIndex(null);
                  return;
               }
               setCurrentPlayingIndex(index);
               props.onSignButtonPress(url);
            }}
            progressALSVideo={
               currentPlayingIndex === index ? props.progressALSVideo : 0
            }
            isMediaPlaying={props.isMediaPlaying}
            onMediaClicked={() => {
               props.onMediaClicked(currentPlayingIndex === index);
               if (currentPlayingIndex === index) {
                  setCurrentPlayingIndex(null);
                  return;
               }
               setCurrentPlayingIndex(index);
            }}
            onMediaFinished={() => {
               //To stop the progress bar
               setCurrentPlayingIndex(null);
            }}
            isPlaying={index === currentPlayingIndex}
         />
      );
   };
   const QuestionHeaderComponent = ({isSmallScreen}) => {
      logger("Do we have an image? ", isImageAvailable);
      return (
         <View style={{flex: 1, flexDirection: 'row'}}>
            <View
               style={{
                  flex: isImageAvailable ? 0.8 : 1,
                  // marginTop: isLandscapeMode ? 0 : 0,
                  marginLeft: isLandscapeMode ? 25 : 16,
                  marginRight: isLandscapeMode ? 25 : 16,
                  flexDirection: 'row',
               }}>
               <Text
                  style={{
                     marginTop: isLandscapeMode ? 16 : 8,
                     fontSize: isLandscapeMode ? 32 : 20,
                     fontFamily: FONT_FAMILY_BOLD,
                     color: 'white',
                     fontWeight: '600',
                     ...Platform.select({
                        web: {
                           marginTop: isLandscapeMode ? 16 : 8,
                           fontSize: isLandscapeMode ? 32 : 20,
                        },
                     }),
                  }}>
                  {finalQuesAnsData?.Question.replace(
                     isMacOS ? /\u0019/g : '\u0019',
                     "'",
                  )}
                  {/*tempQues*/}
               </Text>
            </View>
            {isImageAvailable ? (
               <View style={{flex: 0.2, marginTop: isLandscapeMode ? 24 : 8}}>
                  <ImageQuestionHeader
                     width={isLandscapeMode ? 150 : 100}
                     height={isLandscapeMode ? 52 : 50}
                     magnifierImageWidth={
                        !isWeb
                           ? isLandscapeMode
                              ? 40
                              : 30
                           : isLandscapeMode
                           ? 50
                           : 30
                     }
                     magnifierImageHeight={
                        !isWeb
                           ? isLandscapeMode
                              ? 40
                              : 30
                           : isLandscapeMode
                           ? 50
                           : 30
                     }
                     imageURL={imageURL}
                     onClick={() => {
                        onImageViewerPressed();
                     }}
                  />
               </View>
            ) : null}
         </View>
      );
   };
   return (
      <FlatList
         ListHeaderComponent={
            <QuestionHeaderComponent isSmallScreen={() => isSmallScreen()} />
         }
         ref={flatListRef}
         data={answer}
         renderItem={renderItem}
         numColumns={1}
         keyExtractor={item => item.AnswerID}
      />
   );
};

export default ReviewQuestionList;
